import { CognitoUserPool } from 'amazon-cognito-identity-js';
export const movePoolData = {
  UserPoolId: process.env.REACT_APP_USER_MOVE_POOL_ID,
  ClientId: process.env.REACT_APP_CLIENT_ID_MOVE,
};
export const viewPoolData = {
  UserPoolId: process.env.REACT_APP_USER_VIEW_POOL_ID,
  ClientId: process.env.REACT_APP_CLIENT_ID_VIEW,
};
export const MoveUserPool = new CognitoUserPool(movePoolData);
export const ViewUserPool = new CognitoUserPool(viewPoolData);
